module.exports = __webpack_public_path__ + "img/recommed-img3.c91f844c.jpg";